import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Github, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="glass-card border-t border-gray-800/50 mt-20">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-cyan-400 to-teal-500 flex items-center justify-center font-bold text-xl text-gray-900">
                SS
              </div>
              <div>
                <div className="text-lg font-bold font-poppins">Script Saint</div>
                <div className="text-xs text-gray-400">scriptsaint.com</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Buy prebuilt, well-documented, and deployable production-ready code.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-semibold text-white mb-4">Products</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/shop" className="hover:text-white transition">All Products</Link></li>
              <li><Link to="/portfolio" className="hover:text-white transition">Portfolio</Link></li>
              <li><Link to="/documentation" className="hover:text-white transition">Documentation</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
              <li><Link to="/blog" className="hover:text-white transition">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">Contact</Link></li>
              <li><Link to="/faq" className="hover:text-white transition">FAQ</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-semibold text-white mb-4">Connect</h4>
            <div className="flex space-x-4">
              <a href="mailto:contact@scriptsaint.com" className="text-gray-400 hover:text-white transition" aria-label="Email">
                <Mail size={20} />
              </a>
              <a href="https://github.com/scriptsaint" className="text-gray-400 hover:text-white transition" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
                <Github size={20} />
              </a>
              <a href="https://twitter.com/scriptsaint" className="text-gray-400 hover:text-white transition" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} Script Saint. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;